import { render } from "./OtpInput.vue?vue&type=template&id=6d5e60e4"
import script from "./OtpInput.vue?vue&type=script&lang=js"
export * from "./OtpInput.vue?vue&type=script&lang=js"
script.render = render

export default script